<template>
  <div ref="element" v-auto-animate class="step-info" :class="{ open: isOpen }">
    <div class="panel-heading toggle" role="button" @click="toggleStep">
      <span> {{ title }} </span>
      <icon :icon="toggleIcon" size="sm" />
    </div>

    <div v-if="isOpen" class="toggle-content">
      <div class="content">
        <slot name="content" />
      </div>
      <div class="closing-toggle" @click="isOpen = false">
        <span class="label">Info sluiten</span>
        <icon icon="chevron-up" size="sm" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import Icon from '../../../vue-elements/icon/Icon.vue';
import { logAnalyticsEvent } from '../../../../assets/js/helpers/bananas';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  scrollAlign: {
    type: String,
    default: 'center',
    validator: value => ['start', 'end', 'center'].includes(value)
  }
});
const isOpen = ref(false);
const element = ref(null);
const toggleIcon = computed(() => (isOpen.value ? 'x-fa-info-circle' : 'info-circle'));

const toggleStep = () => {
  isOpen.value = !isOpen.value;
  logAnalyticsEvent('compare-energy.wizard-tooltip', {
    open: isOpen.value,
    title: props.title,
  });
  if (isOpen.value) {
    element.value.scrollIntoView({
      behavior: 'smooth',
      block: props.scrollAlign,
    });
  }
};
</script>

<style lang="scss">
@use 'assets/scss/_variables/colors';
@use 'assets/scss/_helpers/border';
@use 'assets/scss/_helpers/display';
@use 'assets/scss/_helpers/typography';

.step-info {
  margin-top: 16px;
  scroll-margin: 16px;

  .toggle {
    --toggle-color: #{colors.$link-base-default};

    transition-property: color, background-color;
    transition-duration: 0.2s;
    transition-duration: ease-in-out;

    @include typography.link-default;

    padding-bottom: 2px;
    display: inline-flex;
    align-items: center;
    color: var(--toggle-color);
    border-bottom: dotted 2px var(--toggle-color);

    &:hover {
      --toggle-color: #{colors.$link-base-hover};
    }

    .icon-element {
      background-color: var(--toggle-color);
      transition: inherit;
      margin-left: 8px;
    }
  }

  .toggle-content {
    @include border.radius(xl);

    padding: 16px;
    position: relative;
    margin-top: 12px;
    border: 1px solid colors.$border-base;
    background: colors.$grey-10;
    font-size: 1rem;

    .closing-toggle {
      @include display.flex-row-start;

      color: colors.$link-base-default;
      font-weight: 700;
      cursor: pointer;
      margin-top: 20px;

      .icon-element {
        background-color: colors.$link-base-default;
        margin-left: 10px;
      }
    }

    &::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      left: 16px;
      bottom: 100%;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 11px solid colors.$border-base;
    }
  }
  

  &.open {
    .toggle {
      --toggle-color: #{colors.$link-base-active};
    }
  }
}
</style>
